import UserGetADATx from '@/src/components/AppComponents/ModalGetADA/GetADA/GetADA';
import { useModalGetADA } from './useModalGetADA';
import styles from './ModalGetADA.module.scss';
import { Button } from '@/src/components/Commons/Button';
import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import { TOKEN_ADA_TICKER } from '@/src/lib/SmartDB/Commons/Constants/constants';

export const ModalGetADA = () => {
    //--------------------------------------
    const { isRefreshing, isOpen, handleOpen, handleClose, txComponentProps } = useModalGetADA();
    //--------------------------------------
    return (
        <>
            <Button mode="outline-no-arrow" size="small" width={100} onClick={handleOpen}>
                Get {TOKEN_ADA_TICKER}
            </Button>
            {isOpen === true ? (
                <div className={styles.modal}>
                    <div className={`${styles.main}`}>
                        <div className={styles.popUp}>
                            <>
                                <header className={styles.headerModal}>
                                    <h2 className={styles.titleModal}>Get {TOKEN_ADA_TICKER}</h2>
                                    <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                        <use href={CLOSE}></use>
                                    </svg>
                                </header>
                                <UserGetADATx {...txComponentProps} />
                            </>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
    //--------------------------------------
};
